import { Module } from 'vuex';
import { RootState } from '@/store';
import ToolState from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state: ToolState = {
    adminInfo: {
        siteTitle: '',
        siteUrl: '',
        twitterUrl: '',
    },
    histories: [],
};

export const ToolStore: Module<ToolState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
